export const environment = {
    production: true,
    appVersion: 'v0.0.0.0',
    environmentName: 'prod',

    appUrl: 'https://www.integrity-assured.com',
    apiUrl: '',

    docApi: 'https://api.integrity-assured.com/document/api/',
    iceApi: 'https://api.integrity-assured.com/ice/api/',
    idmApi: 'https://api.integrity-assured.com/idm/api/',
    mgmtApi: 'https://api.integrity-assured.com/management/api/',
    paramsApi: 'https://api.integrity-assured.com/pram/api/',
    reportApi: 'https://api.integrity-assured.com/reports/api/',
    uploadAPi: 'https://api.integrity-assured.com/upload/api/',  
    reportApp: 'https://idms-reports.azurewebsites.net/',
    cdmsApi: 'https://api.integrity-assured.com/ca/api/',

    anonymousApi: 'https://api.integrity-assured.com/open/api/',
    anonymousEmailApi: 'https://api.integrity-assured.com/open/api/',
    contactUsLink: 'https://www.integrity-assured.com/contact-us',

    postLogoutRedirectUri: 'https://www.integrity-assured.com/landing',
    redirectUri: 'https://www.integrity-assured.com/landing',

    scopes: ['https://EnerpacIDM.onmicrosoft.com/iceapi/read'],
    uri: 'https://www.integrity-assured.com',

    b2cPolicies: {
        names: {
            signUpSignIn: 'B2C_1A_IDMS_EMAILLOGIN_HRD_SUSI',
            resetPassPolicy: 'B2C_1A_IDMS_PASSWORDRESETEMAIL',
            editProfile: 'B2C_1_iDMS_ProfileEdit',
            signUp: 'B2C_1_iDMS_DemoUserSignUp',
        },
        authorities: {
            signUpSignIn: {
                authority: 'https://enerpacidm.b2clogin.com/enerpacidm.onmicrosoft.com/B2C_1A_IDMS_EMAILLOGIN_HRD_SUSI/',
            },
            resetPassPolicy: {
                authority: 'https://enerpacidm.b2clogin.com/enerpacidm.onmicrosoft.com/B2C_1A_IDMS_PASSWORDRESETEMAIL/',
            },
            editProfile: {
                authority: 'https://enerpacidm.b2clogin.com/enerpacidm.onmicrosoft.com/B2C_1_iDMS_ProfileEdit/',
            },
            signUp: {
                authority: 'https://enerpacidm.b2clogin.com/enerpacidm.onmicrosoft.com/B2C_1_iDMS_DemoUserSignUp/',
            },
        },
        authorityDomain: 'enerpacidm.b2clogin.com',
    },
    showDevButton: false,
    enableAppInsights:true
};
